import Header from "../home/header" 
import Footer from "../home/footer" 
const term=()=>{
    return(
        <>
            <Header/>
            <div className="container-fluid">
                <div className="container p-5">
                     <h1 class="display-5">Term of Services</h1>

                     <p class="text-secondary">
                    <span class="text-dark">1. Services Provided:</span><br/>
                    - We offer digital marketing services including web development, mobile app development, SEO, and graphic design.<br/>
                    - All services are provided in accordance with the specifications and requirements agreed upon with the client.<br/><br/>
        
                    <span class="text-dark">2. Payment Terms:</span><br/>
                    - Clients are required to pay an advance payment of [specify percentage]% of the total project cost before commencement of work.<br/>
                    - Once the project has started, the advance/token payment is non-refundable.<br/>
                    - The remaining balance is due upon completion of the project and before final delivery.<br/>
                    - Payments can be made via [CARD, UPI, DRAFT, NFT].<br/><br/>
        
                    <span class="text-dark">3. Project Completion:</span><br/>
                    - We strive to complete projects within the agreed timeline, subject to the timely provision of necessary materials and approvals from the client.<br/>
                    - Any delays caused by the client may result in a revised project timeline.<br/><br/>
        
                    <span class="text-dark">4. Client Responsibilities:</span><br/>
                    - The client is responsible for providing all necessary materials, content, and approvals required for the project.<br/>
                    - Timely responses to queries and requests for feedback are essential to ensure project progress.<br/><br/>
        
                    <span class="text-dark">5. Intellectual Property:</span><br/>
                    - Upon final payment, the client will own the intellectual property rights to the finalized project.<br/>
                    - Any materials provided by the client remain their intellectual property.<br/><br/>
        
                    <span class="text-dark">6. Confidentiality:</span><br/>
                    - We treat all client information as confidential and will not disclose it to any third party without prior consent.<br/><br/>
        
                    <span class="text-dark">7. Revision Policy:</span><br/>
                    - The project includes up to three (3) revision cycles, during which the client may request minor modifications related to existing module functionality and workflow. These revisions are limited to adjustments that do not alter the approved project scope, core logic, or system architecture. Any requests beyond the included revisions or involving major functional changes will be treated as additional work and may be subject to separate timelines and costs.
                    
                    <span class="text-dark">8. Modification and Termination:</span><br/>
                    - Clients may request modifications to the project scope, which may result in additional charges.<br/>
                    - Either party may terminate the agreement with a written notice, subject to any financial obligations accrued up to the termination date.<br/><br/>
        
                    <span class="text-dark">9. Limitation of Liability:</span><br/>
                    - Our liability is limited to the amount of fees paid by the client for the services provided.<br/>
                    - We are not liable for any indirect, consequential, or incidental damages.<br/><br/>
        
                    <span class="text-dark">10. Governing Law:</span><br/>
                    - These terms and conditions are governed by the laws, and any disputes will be resolved in the courts.<br/><br/>
        
                    <span class="text-dark">11. Acceptance:</span><br/>
                        - By engaging our services, the client agrees to these terms and conditions.<br/><br/>
    
               
                    {/* <!-- Please review these terms and conditions carefully. If you agree, please sign and return a copy to initiate the project.<br/> --> */}
                    <span class="text-dark">TEAM AKCODA</span>
                    </p>
                </div>
            </div>
            <Footer/>
        </>
    )
}
export default term